// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { UserRole } from './user-role';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class User extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  jwtToken?: string;
  newPassword?: string;

  get displayName() {
    return `${this.firstName} ${this.lastName}`
  }

  get displayRoles() {
    let roles = null;
    if (!!this.userRoles) {
        const userRoles = _(this.userRoles).orderBy('role.name');
        userRoles.forEach((x) => {
            if (!!roles) roles += `  --  ${x.role.name}`;
            else roles = x.role.name;
        });
    }
    return roles;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  active!: boolean;
  email?: string;
  firstName?: string;
  lastName?: string;
  password?: string;
  passwordSalt?: string;
  userName?: string;
  userRoles!: UserRole[];
}

